import { useCallback, useRef, useState, useEffect } from 'react';

const useStateCallback = initialState => {
  const [state, dispatch] = useState(initialState);

  const callbackRef = useRef();

  const setState = useCallback((newState, callback) => {
    if (callback && typeof callback !== 'function') {
      throw new Error('useStateCallback: callback must be a function. ');
    }

    callbackRef.current = callback;
    dispatch(newState);
  }, []);

  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current();
    }
  }, [state]);

  return [state, setState];
};

export default useStateCallback;
